import './CardGrid.scss';

import { Button } from '../Button/Button';
import AddToCartIcon from '../../../images/add-to-cart.png';
import { useContext } from 'react';
import { PortContext } from '../../../service/MessageChannelContext';

const content = {
  1: {
    en: 'Step 1',
    id: 'Langkah 1',
  },
  2: {
    en: 'Step 2',
    id: 'Langkah 2',
  },
  3: {
    en: 'Step 3',
    id: 'Langkah 3',
  },
  4: {
    en: 'Step 4',
    id: 'Langkah 4',
  },
  5: {
    en: 'Step 5',
    id: 'Langkah 5',
  },
  6: {
    en: 'Step 6',
    id: 'Langkah 6',
  },
  7: {
    en: 'Step 7',
    id: 'Langkah 7',
  },
  8: {
    en: 'Step 8',
    id: 'Langkah 8',
  },
  9: {
    en: 'Step 9',
    id: 'Langkah 9',
  },
  10: {
    en: 'Step 10',
    id: 'Langkah 10',
  },
};

function convertToCurrency(value) {
  return value.toLocaleString('id-ID', { style: 'currency', currency: 'IDR', minumumFractionDigits: 0, maximumFractionDigits: 0 });
}

export const CardGrid = ({ items = [], showStepNo, addToCardText, onAddToCart, isOffline = false }) => {
  return (
    <div className="card-grid">
      {items.map((item, index) => (
        <div key={index}>
          <RoutineCard {...{ showStepNo, addToCardText, onAddToCart, isOffline, ...item }} />
        </div>
      ))}
    </div>
  );
};

const RoutineCard = ({ stepId, category, product, showStepNo, addToCardText, onAddToCart, isOffline }) => {
  const { lang } = useContext(PortContext);

  return (
    <div className="routine-card">
      {showStepNo && <div className="step-no">{content[stepId][lang]}</div>}
      <div className="category">{category}</div>
      <ProductCard {...{ addToCardText, onAddToCart, isOffline, ...product }} />
    </div>
  );
};

const ProductCard = ({ name, imageUrl, price, discountPrice, productId, addToCardText, onAddToCart, isOffline }) => {
  const hasDiscount = discountPrice && discountPrice < price;
  const discount = hasDiscount ? Math.round(((price - discountPrice) / price) * 100) : 0;
  return (
    <div className="product-card">
      <div className="product-image-container">
        <img className="product-image" src={imageUrl} alt={name} />
        {hasDiscount && <div className="discount-overlay">-{discount}%</div>}
      </div>
      <div className={isOffline ? 'product-body-offline' : 'product-body'}>
        <div className="product-name">{name}</div>
        {hasDiscount && <div className="old-price">{convertToCurrency(price)},-</div>}
        <div className="price">{convertToCurrency(hasDiscount ? discountPrice : price)},-</div>
        {isOffline ? (
          <></>
        ) : (
          <Button text={addToCardText} onClick={() => onAddToCart(productId)} icon={AddToCartIcon} iconPosition={'prefix'} />
        )}
      </div>
    </div>
  );
};
